<template>
  <!-- <div v-if="loading" class="view-schedule-loading">Loading...</div> -->
  <div v-if="loading" class="loading-container">
    <div class="view-schedule-loading">Loading...</div>
    <div class="spacer"></div>
  </div>
  <div v-else class="ViewSchedule">
    <div class="sidebar">
      <div
        v-for="(day, key) in daysOfWeek"
        :key="key"
        class="radio-pill radio-pill-vertical"
      >
        <input
          type="radio"
          :id="'day-' + key"
          :value="day.slug"
          name="days"
          v-model="active"
          @click="handleSelect"
        />
        <label :for="'day-' + key">{{ day.text }}</label>
      </div>
    </div>
    <div class="mobile-dropdown">
      <select class="pill" v-model="active" @change="handleSelect">
        <option v-for="(day, key) in daysOfWeek" :value="day.slug" :key="key">
          {{ day.text }}
        </option>
      </select>
    </div>
    <div class="content a-hover">
      <div
        v-for="(day, key) in getPosts"
        :id="day.dateStr"
        :key="key"
        class="day-wrapper"
        ref="dayDivider"
      >
        <div v-for="(item, key) in day.posts" :id="key" :key="key">
          <div
            v-if="item.dayChanged"
            :id="item.dayChanged - 1"
            class="day-divider"
          >
            {{ item.customDateStr }}
          </div>
          <router-link :to="`schedule/${item.id}/${item.slug}`">
            <div
              v-if="item.id === nowPlayingId"
              class="now-playing-wrapper"
              ref="nowPlaying"
            >
              <NowPlaying :item="item" />
            </div>
            <div
              v-else-if="!item.dj || !item.showName || isCondensed(item.dj)"
              class="schedule-details-condensed"
            >
              <h1>
                {{ item.formattedStart }} to
                {{ item.formattedEnd }}
              </h1>
              <h1>{{ item.dj }} {{ item.showName }}</h1>
            </div>
            <div v-else class="schedule-details">
              <h1>
                {{ item.formattedStart }} to
                {{ item.formattedEnd }}
              </h1>
              <h1>{{ item.dj }}</h1>
              <h1>
                {{ item.showName }}
              </h1>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from "@/lib/content-state";
import NowPlaying from "@/components/NowPlaying";
import { DateTime } from "luxon";

export default {
  name: "ViewSchedule",
  components: { NowPlaying },
  mixins: [mixin],
  data() {
    return {
      active: null,
      daysOfWeek: [],
      activePosts: [],
      loading: true,
      clicked: false,
      initialLoad: true,
      dayIntersectionRatios: {},
    };
  },
  mounted() {
    const nowPlayingElement = this.$refs.nowPlaying;
    if (nowPlayingElement && nowPlayingElement[0]) {
      this.$nextTick(() => {
        nowPlayingElement[0].scrollIntoView({ behavior: "auto" });
        window.scrollBy(0, -80);

      });
    }
  },
  computed: {
    schedule() {
      const schedule = this.$store.getters.getSchedule();
      return [...schedule].map((post) => post[1]);
    },
    getPosts() {
      // parses and filters posts from api call
      const posts = this.schedule;
      if (posts && posts.length) {
        let previousDay = null;
        let daysChanged = 0;

        return posts
          .filter((post) => {
            return !post.summary.includes("TBD");
          })
          .map((post) => {
            let startTime = post.startTime;
            let endTime = post.endTime;

            let dj = post.eventTitleMeta.artist;
            let showName = post.eventTitleMeta.eventName;

            //date customization and manipulation
            let dateStr = startTime.split("T")[0];
            let dateobject = DateTime.fromISO(startTime);

            let customDateStr =
                DateTime.now().startOf('day') === dateobject.startOf('day')
                    ? "Today " + dateobject.toFormat("(LL.dd.yy)")
                    : dateobject.toFormat("cccc (LL.dd.yy)");

            const options = {
              weekday: "long",
              month: "long",
              day: "numeric",
            };
            const timeOptions = { hour: "numeric", minute: "numeric" };
            const formattedStart = new Date(startTime).toLocaleTimeString(
              "en-US",
              timeOptions
            );
            const formattedEnd = new Date(endTime).toLocaleTimeString(
              "en-US",
              timeOptions
            );

            // make copy of post to avoid messing up store
            const newPost = { ...post };

            newPost.summary = { dj, showName, dateStr };
            newPost.dj = dj;
            newPost.showName = showName;
            newPost.dateStr = dateStr;
            // TODO: is this used anywhere?
            newPost.date = dateobject.toLocaleString("en-US", options);
            newPost.formattedStart = formattedStart;
            newPost.formattedEnd = formattedEnd;
            newPost.customDateStr = customDateStr;

            //dayChanged key used for day dividers in schedule list
            let dayChanged = false;
            if (previousDay !== dateobject.day) {
              daysChanged++;
              dayChanged = daysChanged;
              previousDay = dateobject.day;
            }
            newPost.dayChanged = dayChanged;

            newPost.slug =
              dj || showName
                ? `${dj.toLowerCase().split(" ").join("-")}${showName
                    .toLowerCase()
                    .split(" ")
                    .join("-")}`.replaceAll("/", "")
                : newPost.showName.replaceAll("/", "");
            return newPost;
          })
          // group posts into days
          .reduce((acc, post) => {
            const dateStr = DateTime.fromISO(post.startTime).toFormat("(LL.dd.yy)")
            post.dayChanged
              ? acc.push({ posts: [post], dateStr })
              : acc[acc.length - 1].posts.push(post);
            return acc;
          }, []);
      } else return [];
    },
    nowPlayingId() {
      return this.$store.getters.getNowPlaying().id;
    },
  },

  methods: {
    setDay(slug) {
      this.active = slug;
    },
    getDays() {
      const posts = this.schedule;
      if (posts && posts.length) {
        this.daysOfWeek = posts
          .filter((post) => {
            return (
              !post.summary.includes("TBD") &&
              DateTime.fromISO(post.startTime) >=
               DateTime.now()
            );
          })
          .map((p) => DateTime.fromISO(p.startTime).toFormat("(LL.dd.yy)"))
          .filter((p, i, a) => a.indexOf(p) >= i)
          .map((d) => {
            let dateobject = DateTime.fromFormat(d, "(LL.dd.yy)");
            let datestring =
                DateTime.now().startOf('day') === dateobject.startOf('day')
                ? "Today " + dateobject.toFormat("(LL.dd.yy)")
                : dateobject.toFormat("cccc (LL.dd.yy)");
            return {
              slug: d,
              text: datestring,
            };
          });
      }
    },
    scrollToDay(key) {
      const dayDivider = this.$refs.dayDivider.find(div => div.id === key);
      if (dayDivider) {
        dayDivider.scrollIntoView({ behavior: "smooth" });
      }
    },
    handleSelect(event) {
      this.active = event.target.value;
      this.scrollTarget = event.target.value;
      this.scrollToDay(event.target.value);
    },
    isCondensed(data) {
      return data.includes("presents");
    },
  },

  updated() {
    // show active day based on what is in view while scrolling
    let dayDivider = this.$refs.dayDivider;
    if (!dayDivider) return;
    const observerOptions = {
      threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // update days
        this.dayIntersectionRatios = {
          ...this.dayIntersectionRatios,
          [entry.target.id]: entry.intersectionRatio,
        };
      });
    }, observerOptions);
    document.querySelectorAll(".day-wrapper").forEach((section) => {
      observer.observe(section);
    });
  },
  watch: {
    dayIntersectionRatios() {
      const ratios = this.dayIntersectionRatios;
      // get day with highest onscreen ratio
      const target = Object.keys(ratios).reduce((acc, day) => {
        return ratios[day] > ratios[acc] ? day : acc
      })

      // if 'scrollTarget' is set, the user clicked on one of the weekday buttons and
      // the page is actively scrolling to the clicked day.
      if (this.scrollTarget) {
        if (target === this.scrollTarget) {
          this.scrollTarget = null;
          this.active = target;
        }
      } else {
        this.active = target;
      }
    },
    nowPlayingId() {
      // TODO: figure out better way to do this
      // Without timeout $refs.nowPlaying doesn't update in time
      setTimeout(() => {
        const nowPlayingElement = this.$refs.nowPlaying[0];

        if (nowPlayingElement) {
          nowPlayingElement.scrollIntoView({ behavior: "auto" });
          window.scrollBy(0, -80);
        }
      }, 100);
    },
    daysOfWeek: {
      immediate: true,
      handler() {
        if (this.daysOfWeek[0]) {
          this.active = 0;
        }
      },
    },
    getPosts: {
      immediate: true,
      handler() {
        if (this.$store.getters.getSchedule().size) {
          this.loading = false;
          this.getDays();
        }
      },
    },
  },
};
</script>

<style scoped>
.ViewSchedule {
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 2rem;
  padding: 2rem 2rem 2rem;
  min-height: 900px;
}

.view-schedule-loading {
  text-align: center;
  width: 100%;
  padding-top: 4%;
  position: fixed;
}

.spacer {
  height: 5000px;
  width: 100vh;
}

.content {
  padding-left: 6.5%;
  padding-right: 6.5%;
}

.sidebar button {
  width: 100%;
  margin-bottom: 2rem;
}

.sidebar {
  position: sticky;
  top: 90px;
  align-self: flex-start;
  margin-top: -5px;
}

select {
  display: none;
  grid-column: 1 / -1;
  width: 100%;
  margin-bottom: 2rem;
}

.schedule-details {
  display: grid;
  width: 100%;
  font-size: 1.4rem;
  border-bottom: 1px solid #000;
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0 10px;
}

.schedule-details-condensed {
  display: grid;
  width: 100%;
  font-size: 1.4rem;
  border-bottom: 1px solid #000;
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  grid-template-columns: 1fr 2fr;
  gap: 0 10px;
}

.day-divider {
  width: 100%;
  border-bottom: 1px solid #000;
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  font-size: 3rem;
  scroll-margin-top: 90px;
}

.thumbnail-image {
  max-height: 100px;
  max-width: 100px;
}

.mobile-dropdown {
  display: none;
}

.day-wrapper {
  scroll-margin-top: 90px;
}

@media (max-width: 1000px) {
  .ViewSchedule {
    grid-template-columns: 1fr;
    padding-top: 0;
  }

  .Feature {
    width: 40vh;
  }

  .sidebar {
    display: none;
  }

  .content {
    padding-left: 0;
    padding-right: 0;
  }

  select {
    display: flex;
    width: 90%;
    justify-content: center;
    margin: 0;
    margin-top: 2rem;
  }

  .mobile-dropdown {
    background: white;
    display: flex;
    justify-content: center;
    position: sticky;
    top: 0px;
    width: 111%;
    margin-left: -19px;
  }

  .day-divider {
    scroll-margin-top: 4px;
  }
}
</style>
